<template>
    <section class="content">
        <div class="overlay-wrapper">
            <div class="card card-primary">
                <div class="overlay" v-if="loadingContent"><h1 style="font-size:40px;">Sedang diproses <i class="fas fa-sync-alt fa-spin"></i></h1></div>
    <div class="card-body">
        <div class="row">
        <div class="col-xl-12 col-md-12 flex">
            <div class="row">
                <div class="col-auto">
                    <h4 class="mb-0">Periode</h4>
                </div>
                <div class="col-12 col-sm-auto">
                    <div class="input-group mb-3">
                        <input type="text" ref="daterange" class="form-control" style="border-right: 0"/>
                        <div class="input-group-append">
                        <div
                            class="input-group-text"
                            style="background-color: #fff">
                            <span><span class="fa fa-calendar"></span></span>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-auto">
                    <select class="form-control" @change="categoryChange($event)">
                        <option value="#" disabled selected>Pilih Kategori</option>
                        <option v-for="cat in categoryGroup" v-bind:key="cat.id" v-bind:value="cat.id">
                            {{ cat.label }}
                        </option>
                    </select>
                </div>
                <div class="col-12 col-sm-auto">
                    <select class="form-control" @change="reconChange($event)">
                        <option value="" selected disabled>Status Rekon</option>
                        <option value="1">Sudah Rekon</option>
                        <option value="0">Belum Rekon</option>
                        <option value="">Semua Rekon</option>
                    </select>
                </div>
                <div class="col-12 col-sm-auto ml-auto">
                    <div class="btn-group" ref="toolbar">
                        <button type="button" data-action="read" class="btn btn-default"><i
                            class="fa fa-sync-alt"></i></button>
                        <button type="button" :disabled="downloading" v-on:click="downloadXlsx"
                            data-action="export-xlsx" class="btn btn-default"><i class="fa fa-download"></i> <span class="d-none d-md-inline-block">Download</span></button>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="mb-2"></div>
            <table style="width:100%" class="table table-hover" ref="tblwinpay">
            <thead>
                <tr>
                    <th>TRANSACTION ID</th>
                    <th>PROVIDER</th>
                    <th>NO. REF</th>
                    <th>CATEGORY</th>
                    <th>TOPUP</th>
                    <th>DIBUAT</th>
                    <th>ADMIN BY SHIPPER</th>
                    <th>ADMIN BY BOSCOD</th>
                    <th>SHIPPER KE BOSCOD</th>
                    <th>BOSCOD KE WINPAY</th>
                    <th>WINPAY KE BOSCOD</th>
                    <th>REKONSILIASI</th>
                </tr>
            </thead>
            <tbody @click="handleClick"></tbody>
            <tfoot>
            <tr>
                <th colspan="10"></th>
                <th></th>
                <th></th>
            </tr>
            </tfoot>
            </table>
    </div>
            </div>
        </div>
    </section>
</template>
<script>
import { authFetch, createTable, formatCurrency } from "@/libs/hxcore";
import Swal from "sweetalert2";
import $ from "jquery";
import Daterangepicker from "daterangepicker";
import moment from "moment";
import "daterangepicker/daterangepicker.css";

export default {
    name: "Reportwinpay",
    data() {
        return {
            dt1: "",
            dt2: "",
            dateStart: "",
            dateEnd: "",
            errors: [],
            method: "",
            jurnal: {
                coa_id: '',
                coa_no: '',
                coa_name: '',
            },
            roles: "",
            role_id: "",
            coa_id: "",
            categoryGroup: [
                {id: 1, label: 'Full Shipper'},
                {id: 2, label: 'Partial Shipper'},
                {id: 3, label: 'Full BosCOD'},
                {id: 0, label: 'Semua'}
            ],
            recon: '',
            category: '',
            downloading: false,
            loadingContent: false,
        };
    },
    created: function () {
        this.roles = this.$route.meta.roles;
        console.log("load initial data", this.$route);
        this.dateStart = moment().add(-1, 'M').startOf("month").format("YYYY-MM-DD");
        this.dateEnd = moment().format("YYYY-MM-DD");
    },
    methods: {
        onPeriode() {
        this.tbl.api().ajax.reload();
        },
        handleClick(e) {
            const er = this.$refs;
            if (e.target.matches(".link-role")) {
            }
        },
        categoryChange(event) {
            this.category = event.target.value;
            this.tbl.api().ajax.reload();
        },
        reconChange(event) {
            this.recon = event.target.value;
            this.tbl.api().ajax.reload();
        },
		downloadXlsx: function (e) {
			this.downloading = true;
			var filter = {};
                filter.q = $("input[name=q]").val();
                filter.category = $("select[name=category]").val();
                filter.dt1 = this.dateStart;
                filter.dt2 = this.dateEnd;
                filter.category_payment = this.category;
                filter.reconciled = this.recon;
			var data = Object.keys(filter)
				.map(
					(key) =>
					encodeURIComponent(key) + "=" + (filter[key] === false ? 0 : encodeURIComponent(filter[key]))
				)
				.join("&");
			console.log(data)
            this.loadingContent = true;
			authFetch("/report/winpay/excell", {
                method: "POST",
                body: data,
            })
            .then((response) => {
                if (response.status === 201) {
                } else if (response.status === 400) {
                } else if (response.status === 500){
                    Swal.fire("Timeout!", ``, "error");
                    return false;
                }

                return response.blob();
            })
            .then((blob) => {
                setTimeout(() => {
                    this.downloading = false;
                }, 1000);
                this.loadingContent = false;
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement("a");
                a.href = url;
                a.download = "data.xlsx";
                document.body.appendChild(a);
                a.click();
                a.remove();
            });
		}
    },
    mounted() {
    const e = this.$refs;
    const self = this;
    new Daterangepicker(this.$refs.daterange, {
        startDate: moment().add(-1, 'M').startOf("month"),
        endDate: moment(),
        locale: {
            format: 'DD/MM/YYYY'
        }
        }, function (d1, d2) {
        self.dateStart = d1.format("YYYY-MM-DD");
        self.dateEnd = d2.format("YYYY-MM-DD");
        self.onPeriode();
        });
    
    this.tbl = createTable(e.tblwinpay, {
        title: "",
        ajax: "/report/winpay",
        roles: this.$route.params.roles,
        toolbarEl: e.toolbar,
        selectedRowClass: "",
        serverSide: true,
        frame: false,
        scrollX: true,
        processing: true,
        autoWidth: false,
        sort: false,
        language: {
            processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'},
        "order": [
            [7, 'desc']
        ],
        paramData: function (d) {
            d.dt1 = self.dateStart;
            d.dt2 = self.dateEnd;
            d.category_payment = self.category;
            d.reconciled = self.recon;
        },
        columns: [
            { data: "transaction_id" },
            { data: "provider",
            sortable: false,
            render: function(data, type, row, meta){
                return "Winpay";
            } },
            { data: "ref_code" },
            { data: "category",
            render: function(data, type, row, meta){
                if (row.admin_fee > 0 && (row.admin_boscod == 0 || row.admin_boscod < 0)) {
                    return "Full Shipper";
                } else if (row.admin_fee > 0 && row.admin_boscod > 0) {
                    return "Partial Shipper";
                } else if (row.admin_fee == 0 && row.admin_boscod > 0) {
                    return "Full BosCOD";
                } else {
                    return "-";
                }
            } },
            { data: "debit" },
            { 
            data: "created_on",
            class:'text-right',
            render: function(data, type, row, meta) {
                return !data ? '' : moment(data).format("DD/MM/YYYY");
            } },
            { 
            data: "admin_fee",
            class:'text-right',
            render: function(data, type, row, meta) {
                if (data > 0) {
                    return "Rp " + formatCurrency(data);
                } else {
                    return "Rp 0";
                }
            } },
            { 
            data: "admin_boscod",
            class:'text-right',
            render: function(data, type, row, meta) {
                if (data > 0) {
                    return "Rp " + formatCurrency(data);
                } else {
                    return "Rp 0";
                }
            } },
            { 
            data: "total_amount",
            class:'text-right',
            render: function(data, type, row, meta) {
                if (data > 0) {
                    return "Rp " + formatCurrency(data);
                } else {
                    return "Rp 0";
                }
            } },
            { 
            data: "total_amount",
            class:'text-right',
            render: function(data, type, row, meta) {
                if (data > 0) {
                    return "Rp " + formatCurrency(data);
                } else {
                    return "Rp 0";
                }
            } },
            { 
            data: "deposit_admin", 
            class:'text-right',
            render: function(data, type, row, meta) {
                return "Rp " + formatCurrency(data);
            } },
            { 
            data: "reconciled",
            class:'text-right',
            render: function(data, type, row, meta) {
                if (data > 0) {
                    return moment(row.reconciled_on).format('DD/MM/YYYY');
                } else {
                    return "-";
                }
            } }
        ],
        filterBy: [0,2],
        rowCallback: function (row, data) {},
        footerCallback:function ( row, data, start, end, display ){
        var api = this.api(), data;
            // Total over this page
            var totalWinpayToBoscod;
            totalWinpayToBoscod = 
                api
                .column(10)
                .data()
                .reduce( function (a, b) {
                    var x = parseFloat( a ) || 0;
                    var y = parseFloat( b ) || 0;
                    return x + y;
                }, 0);

            // Update footer
            $( api.column(10).footer() ).html(
                'Rp '+ formatCurrency(totalWinpayToBoscod)
            );
        },
        initComplete: function () {
            $('.loading-overlay').removeClass('show');
        },
        });
    },
}
</script>